// libraries
import React, { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled, { useTheme } from 'styled-components';

// assets and components
import { COLORS } from '../../utils/theme/colors';
import ApportionmentIcon from '../atoms/icons/ApportionmentIcon';

const Sidebar = ({ setIsSidebarExpanded, isSidebarExpanded }) => {
  const [isSelected, setIsSelected] = useState(window.location.pathname);
  const routes = useSelector((state) => state.user?.routes);

  const colorTheme = useTheme();

  useEffect(() => {
    setIsSelected(location.pathname);
  }, [location.pathname]);

  const isRouteSelected = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <SidebarWrapper
      onMouseEnter={() => {
        setIsSidebarExpanded(true);
      }}
      onMouseLeave={() => {
        setIsSidebarExpanded(false);
      }}
      {...{ isSidebarExpanded }}
    >
      <SidebarItemsContainer isSidebarExpanded={isSidebarExpanded}>
        {routes &&
          routes.map(
            ({ title, path, isMenuSidebarItem, menuIcon }, index) => {
              if (title != 'Rateio' && isMenuSidebarItem) {
                return (
                  <SidebarItem key={index} isSidebarExpanded={isSidebarExpanded} isSelected={isRouteSelected(path)} onClick={() => setIsSelected(path)}>
                    <Link className={`link_sidebar_item ${isRouteSelected(path) ? 'selected' : ''}`} to={path}>
                      <span>{menuIcon(isRouteSelected(path) ? colorTheme.selectedIcon : COLORS.unselected)}</span>
                      {isSidebarExpanded && (
                        <p className={isRouteSelected(path) ? 'selected' : ''}>{T(title)}</p>
                      )}
                    </Link>
                  </SidebarItem>
                );
              }
              else if (title === 'Rateio' && isMenuSidebarItem && localStorage.getItem('theme') == 'celesc') {
                return (
                  <SidebarItem key={index} isSidebarExpanded={isSidebarExpanded} isSelected={'/apportionment' === isSelected}>
                    <a className={`link_sidebar_item ${isSelected === '/apportionment' ? 'selected' : ''}`} href="https://datastudio.google.com/s/jVHhkUDA_VU" target="_blank" rel="noopener noreferrer">
                      <span>
                        <ApportionmentIcon fill={isSelected === '/apportionment' ? colorTheme.selectedIcon : COLORS.unselected} />
                      </span>
                      <p className={isSelected === '/apportionment' ? 'selected' : ''}>Rateio</p>
                    </a>
                  </SidebarItem>
                );
              }
              else {
                return;
              }
            }
          )}
      </SidebarItemsContainer>
    </SidebarWrapper>
  );
};

export default Sidebar;

const SidebarWrapper = styled.div`
  position: fixed;
  display: none;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  left: 0;
  width: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '240px' : '80px;')};
  height: 100vh;
  background-color: ${COLORS.background};
  z-index: 3;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8, 10, 37, 0.03), 0 0.9375rem 1.40625rem rgba(8, 10, 37, 0.03), 0 0.25rem 0.53125rem rgba(8, 10, 37, 0.05), 0 0.125rem 0.1875rem rgba(8, 10, 37, 0.03);
  overflow-y: auto;
  padding-top: 64px;

  &::-webkit-scrollbar {
    width: 0px;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  img {
    transition: 200ms ease-in-out;
    transform: ${({ isSidebarExpanded }) => (isSidebarExpanded ? 'none' : 'translateX(-25px) scale(0.6)')};
  }

  svg {
    position: relative;
    top: 3px;
  }

  @media (min-width: 1025px) {
    display: flex;
    position: fixed;
    height: 100%;
    overflow-y: auto;
  }
`;

const SidebarItemsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;

  .link_sidebar_item {
    display: flex;
    text-decoration: none;
    color: inherit;
    position: relative;
    padding: 10px 10px 10px 30px;
  }

  .link_sidebar_item.selected::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: ${({ theme }) => theme.selectedDiv};
    z-index: -1;
  }

  .link_sidebar_item:hover::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: ${({ theme }) => theme.hoveredDiv};
    z-index: -1;
  }

  .link_sidebar_item span {
    pointer-events: none;
  }

  .link_sidebar_item p {
    transition: opacity 200ms ease-in-out;
    margin: 1px 0 0 13px;
    white-space: nowrap;
    opacity: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '1;' : '0;')};
  }

  .link_sidebar_item p.selected {
    color: ${({ theme }) => theme.selectedIcon};
  }
`;

const SidebarItem = styled.div`
  text-align: center;
  font-size: 90%;
  color: ${COLORS.lightDarkText};
  transition: color 150ms linear;
  width: 100%;
`;
